/* eslint-disable */
import gql from 'graphql-tag';

export const SAVE_BUILDER = gql`
mutation saveBuilder($eventID: ID!, $items: [JSON!], $backgroundImage: String, $backItems: [JSON!], $backBackgroundImage: String, $hasBackSide: Boolean, $format: String, $orientation: String) {
  saveBuilder(eventId: $eventID, items: $items, backgroundImage: $backgroundImage, backItems: $backItems, backBackgroundImage: $backBackgroundImage, hasBackSide: $hasBackSide, format: $format, orientation: $orientation ) {
    id
    eventId
    items
    backgroundImage
    backItems
    backBackgroundImage
    hasBackSide
    format
    orientation
    
  }
}`;
